import * as React from 'react';
import { InputWrapperWidget } from './inputs';
import { useField } from 'formik';
import { OTPInput, OTPInputProps } from './OTPInput';

export interface FormikInputWidgetProps extends Omit<OTPInputProps, 'error' | 'otpValues' | 'onChange'> {
  name: string;
  length: number;
  error?: string | null;
  autoFocus?: boolean;
  disabled?: boolean;
  className?: any;
}

export const FormikOTPWidget: React.FC<FormikInputWidgetProps> = (props) => {
  const { name, length, error, autoFocus, disabled } = props;
  const [field, meta, helpers] = useField<string[]>(name);
  const errorMsg = meta.touched && (error || meta.error);

  return (
    <InputWrapperWidget className={props.className} error={errorMsg}>
      <OTPInput
        {...props}
        error={false}
        otpValues={field.value}
        length={length}
        autoFocus={autoFocus}
        disabled={disabled}
        onChange={(otp) => {
          helpers.setValue(otp);
        }}
      />
    </InputWrapperWidget>
  );
};
